import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from 'react-share'
import { Icon } from '../../components/Icon'
import { Image } from '../../components/Image'
import { Heading } from '../../components/Heading'
import { RichText } from '../../components/RichText'
import './blogpostsection.scss'
import SubcribeForm from '../../components/SubcribeForm/SubcribeForm'
import { Link } from 'gatsby'

export const BlogPostSection = ({
  otherClasses,
  slug,
  title,
  siteMetadata,
  publishedAt,
  desktopImage,
  mobileImage,
  authors,
  blogCategory,
  toggleFunc,
  _rawBody,
}) => {
  const blogPostSectionClasses = clsx(otherClasses)

  const [copied, setCopied] = useState(false)

  function copy() {
    setCopied(true)
    const el = document.createElement('input')
    el.value = window.location.href
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)
  }

  useEffect(() => {
    let timer
    if (copied) {
      timer = setTimeout(() => setCopied(false), 1000)
    }
    return () => {
      if (timer) clearTimeout(timer)
    }
  }, [copied])

  const shareButtons = siteMetadata && (
    <>
      <FacebookShareButton
        url={`${siteMetadata?.siteUrl}/${slug?.current}/`}
        quote={title}
      >
        <div>
          <Icon icon="gloden-facebook-icon" iconHeight={20} iconWidth={20} />
        </div>
      </FacebookShareButton>
      <LinkedinShareButton
        url={`${siteMetadata?.siteUrl}/${slug?.current}/`}
        quote={title}
      >
        <div>
          <Icon icon="golden-linkedin-icon" iconHeight={19.05} iconWidth={20} />
        </div>
      </LinkedinShareButton>
      <TwitterShareButton
        url={`${siteMetadata?.siteUrl}/${slug?.current}/`}
        quote={title}
      >
        <div>
          <Icon
            icon="golden-twitter-icon"
            iconHeight={14.81}
            iconWidth={18.22}
          />
        </div>
      </TwitterShareButton>
      <button onClick={copy} className="relative w-[20px] h-[20px  ]">
        <p
          className={clsx(
            'absolute w-[89px] text-gray_900 animate-waving-hand font-Work_Sans text-white  font-medium  text-xs bottom-[-30px] left-[-70px] sm:left-[-50px] lg:left-[-30px]',
            copied ? 'opacity-1' : 'opacity-0 '
          )}
        >
          {copied ? 'Link is Copied' : ''}
        </p>
        <Icon icon="golden-link-icon" iconHeight={15.84} iconWidth={15.84} />
      </button>
    </>
  )

  return (
    <section className={blogPostSectionClasses} data-testid="blog-post-section">
      {desktopImage && (
        <Image
          imageData={desktopImage}
          otherClasses="w-full h-[607.66px] !hidden lg:!block"
          objectFit="fill"
        />
      )}
      {mobileImage && (
        <Image
          imageData={mobileImage}
          otherClasses="w-full h-[294.35px] sm:h-[500px] lg:!hidden"
          objectFit="fill"
        />
      )}
      <div className="px-6 xl:px-0">
        <div className="max-w-[1200px] mx-auto w-full -mt-20 lg:mt-[-202px] bg-primary_blue_700 rounded-[20px] py-10 lg:py-16 relative px-6 lg:px-[200px]  mb-16 lg:mb-[120px] ">
          <Heading
            type="h1"
            otherClasses="text-white font-Manrope font-light mb-8"
          >
            {title}
          </Heading>
          <div className="flex flex-col sm:flex-row justify-between w-full gap-6 sm:gap-0 sm:items-end">
            <div className="flex gap-[14px] items-center">
              <Image
                imageData={authors?.customImage}
                otherClasses="rounded-full w-12 h-12"
                imgClassName="rounded-full"
              />
              <div>
                <Link to={authors?.url ? authors?.url : "https://caconsumerlaw.com/attorney-stephanie-pengilley/"} className="text-base font-bold font-Work_Sans text-white leading-6 hover:text-accent_orange_600">
                  {authors?.name}
                </Link>
                <p className="text-white/80 font-normal font-Work_Sans text-base leading-6">
                  {publishedAt && publishedAt}
                </p>
              </div>
            </div>
            <div className="flex items-center gap-6">{shareButtons}</div>
          </div>
        </div>
      </div>
      <article className="max-w-[1055px] mx-auto w-full px-6 xl:px-0">
        <RichText
          richText={_rawBody}
          otherClasses="blog_post_section_rich_text"
          toggleFunc={toggleFunc}
        />
      </article>
      <div className="px-6 xl:px-0">
        <SubcribeForm otherClasses="mt-16 lg:mt-[120px]" />
      </div>
    </section>
  )
}

export default BlogPostSection
